// Exports
export default {
	"startScreenPopup": "startScreenPopup_XaMW1",
	"root": "root_adLwP",
	"content": "content_KLQNi",
	"title": "title_ushBf",
	"connectButton": "connectButton_+SZY6",
	"meetingIdInputWrapper": "meetingIdInputWrapper_BhzXK",
	"hasError": "hasError_YQCs4",
	"connectToMeetingShake": "connectToMeetingShake_Z8qOm"
};
